import { EventPublishingStore } from "./EventPublishingStore";
// Shim store identifier
export const ShimStoreId = "flux:shim";
/**
 * A placeholder (non-reactive) store implementation that gets returned until a dynamically loaded store
 * has been downloaded. This allows the runtime to specify some meaningful default behavior for a store
 * until the reactive JS is available.
 *
 * Other option is to return a null reference, but that requires the consumers to handle the null reference
 * correctly and gracefully at every call site, which is cumbersome. Instead we define the default behavior
 * at one place and have it applied at all call sites.
 */ export class ShimStore extends EventPublishingStore {
    get name() {
        return ShimStoreId;
    }
    // Shim store is non-reactive by design, as it's only a placeholder to server default values for store API's
    handleAction() {
        throw new Error("IllegalActionDispatchToShimStore");
    }
}
